<template>
  <v-container id="pripady-table-wrapper" class="pa-0" :class="{ 'pb-86px' : isMobile }">
    <h1 v-if="isMobile" class="ma-4">Dokumenty</h1>

    <div :class="{ 'd-flex align-center': !isMobile }">
      <v-btn
        class="btn-primary"
        :class="{ 'mt-5 mb-3': !isMobile, 'mx-4': isMobile }"
        :style="isMobile ? { width: '-webkit-fill-available' } : {}"
        @click="dialog = true"
      >
        Nahrať dokument
      </v-btn>
      <v-btn
        v-if="!isMobile"
        class="btn-secondary mt-5 mb-3 ml-5"
        @click="goBack"
      >
        Späť
      </v-btn>
    </div>

    <dokumenty-upload-dialog
      v-model="dialog"
      :new-id="newId"
      :cislo-predmetu="cisloPredmetu"
      :poznamka-default="poznamka"
      @uploaded="loadData(null)"
    />

    <template v-if="!isMobile">
      <v-data-table
        v-model="selected"
        :disable-pagination="false"
        :headers="headers"
        :items="items"
        hide-default-footer
        :page.sync="page"
        :items-per-page="10"
        @page-count="pageCount = $event"
        :single-select="false"
        :single-expand="false"
        item-key="id_dokumentu"
        :loading="loading"
        loading-text="Načítavam dáta ..."
      >
        <template v-slot:[`item.stav`]="{ item }">
          <v-switch
            @change="updateStatus(item.id_dokumentu, item.stav)"
            v-model="item.stav"
          ></v-switch>
        </template>

        <template v-slot:[`item.datum_aktualizacie`]="{ item }">
            <span v-if="item.datum_aktualizacie">{{
            item.datum_aktualizacie.formatDate()
            }}</span>
        </template>

        <template v-slot:[`item.akcie`]="{ item }">
          <v-menu
            content-class="pripady-table-menu"
            offset-x
            transition="slide-x-transition"
            left
            open-on-hover
            nudge-left="5"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn :dark="$vuetify.theme.dark" icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list id="pripady-table-menu-list" elevation="1">
              <v-list-item
                link
                dense
                v-for="(m, i) in menu"
                :key="i"
                :class="m.color"
                @click="
                  actionClick(
                    m.nazov,
                    item.new_id,
                    item.cislo_verzie,
                    item.pripona,
                    item.nazov_dokumentu
                  )
                "
              >
                <v-list-item-icon class="mr-4">
                  <v-icon v-text="m.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ m.nazov }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </template>
    <template v-else>
      <v-row v-if="loading">
        <v-col class="ml-4">
          Načítavam dáta ...
        </v-col>
      </v-row>
      <template v-else>
        <template v-if="items.length > 0">
            <v-row no-gutters class="mobile-dokumenty-card d-flex flex-wrap" v-for="(item, index) in items" :key="index">
                <v-col v-for="header in headers.filter(h => h.value !== 'akcie' && !(h.value == 'poznamka' && item.poznamka == null))"
                       :key="header.value" cols="12" class="pt-4">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <span class="f12 gs100 break-word">{{ header.text }}</span>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <span class="f16 bold break-word">{{ item[header.value] }}</span>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12">
                    <v-divider class="my-16px"></v-divider>
                </v-col>
                <v-btn 
                  class="btn-secondary btn-icon mx-4 mb-6 mt-2"
                  style="border: 0 !important;"
                  @click="actionClick(
                  'Zobraziť dokument',
                  item.new_id,
                  item.cislo_verzie,
                  item.pripona,
                  item.nazov_dokumentu
                  )"
                ><v-icon class="f24" color="#0097fd">mdi-file-document-outline</v-icon></v-btn
                >
                <v-btn 
                  class="btn-secondary btn-icon mb-6 mt-2"
                  style="border: 0 !important;"
                  @click="actionClick(
                  'Zmazať',
                  item.new_id,
                  item.cislo_verzie,
                  item.pripona,
                  item.nazov_dokumentu
                )"
    ><v-icon class="f20" color="#0097fd">$trash</v-icon></v-btn
    >
      </v-row>
      </template>
        <template v-else>
          <v-row>
            <v-col class="ml-4">
              Nie sú dostupné žiadne dáta.
            </v-col>
          </v-row>
        </template>
      </template>
    </template>
    <template v-if="isMobile">
      <div class="mobile-bottom-div">
        <v-btn @click="goBack" class="btn-primary ma-4" style="width: -webkit-fill-available">
          Späť
        </v-btn>
      </div>
    </template>
  </v-container>
</template>
<script>
import protectedAxios from '../../auth/axios';
import Status from '../basic/Status.vue';
import Utils from '../../plugins/utils';
import { dmsHelper } from '../../mixins/dmsHelperMixin';
import { mapGetters } from 'vuex';
import DokumentyUploadDialog from './DokumentyUploadDialog.vue';

export default {
  mixins: [dmsHelper],
  components: { Status, Utils, DokumentyUploadDialog },
  methods: {
    goBack() {
      const newId = this.$route.params.new_id;
      switch (this.$route.query.returnTo) {
        case 'dashboard':
          this.$router.push('/');
          break;
        case 'obchodne-pripady':
          this.$router.push('/obchodne-pripady');
          break;
        case 'sumar-zadatel':
          this.$router.push(`/obchodny-pripad/${newId}/sumar/najomca`);
          break;
        case 'sumar-predmet':
        default:
          this.$router.push(`/obchodny-pripad/${newId}/sumar`);
          break;
      }
    },
    async loadData(filter) {
      this.editDialog = false;
      this.createDialog = false;
      this.editId = 0;
      this.loading = true;
      this.items = [];
      this.selected = [];
      this.newId = this.$route.params.new_id;
      this.cisloLz = '';
      this.cisloPlz = '';
      this.cisloPredmetu = this.$route.params.cisloPredmetu;

      this.poznamka = decodeURIComponent(this.$route.params.poznamka);
      if (this.poznamka == 'poznamka') this.poznamka = ''; //ak je text poznamka tak ho zamenim za prazdny znak koli tomu aby som vedel dostat param do url,leboprazdny znak v url je blbost
        //console.warn(this.cisloPredmetu);
        this.newIdFilter = this.newId;
      if (
        !isNaN(parseFloat(this.cisloPredmetu)) &&
        isFinite(this.cisloPredmetu) &&
        this.cisloPredmetu != '0'
      ) {
        this.newIdFilter = this.newId + '-' + this.cisloPredmetu;
      }

      protectedAxios
        .get(
          `dokumenty?newId=${this.newIdFilter ?? ''}&cisloLZ=${this.cisloLz ?? ''}&cisloDokladu=${this.cisloDokladu ?? ''}`
        )
        .then(res => (this.items = res.data ? res.data : []))
        .catch(e => {
          console.error(e);
          this.items = [];
        })
        .finally(() => (this.loading = false));
    },
    actionClick(akcia, new_id, verzia_dokumentu, pripona, nazov_dokumentu) {
      switch (akcia) {
        case 'Zmazať':
          this.deleteDokument(new_id, verzia_dokumentu);
          break;
        case 'Zobraziť dokument':
          this.showDokument(new_id, verzia_dokumentu, pripona, nazov_dokumentu);
          break;
        default:
          break;
      }
    },
    deleteDokument(id) {
      protectedAxios
        .delete(`dokumenty/${this.newId}/${id}`)
        .then(res => {
            this.items = this.items.filter(x => x.new_id != id);
        })
        .catch(e => {
            console.error(e);
        });
    },
    showDokument(id_dokumentu, verzia_dokumentu, pripona, nazov_dokumentu) {
      this.idDokumentu = id_dokumentu;
      this.verziaDokumentu = verzia_dokumentu;
      this.downloadingDMS = true;

      console.warn(nazov_dokumentu);
      console.warn(pripona);
      console.warn(verzia_dokumentu);
      console.warn(id_dokumentu);

      const newWindow = window.open(
        '',
        '_blank'
      );

      protectedAxios
        .get('tlac/getdokumentpdfdms', {
          params: {
            newId: this.idDokumentu,
            verzia: this.verziaDokumentu,
          },
        })
        .then(res => {
          if (res.data.error == 0 && res.data.message.length > 0) {
            this.messageOk = res.data.message;
          } else if (res.data.error > 0) {
            this.messageErr = res.data.message;
          }

          if (res.data.error == 0) {
            //this.pdfDataShow(res.data.data, nazov_dokumentu, pripona);
            newWindow.location.href = window._env_config.API_URL +
              '/dms/file?uid=' +
              res.data.fileUid +
              '&show=true';
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  mounted() {
    this.loadData();
  },
  data() {
    return {
      dialog: false,
      editId: 0,
      page: 1,
      pageCount: 0,
      selected: [],
      loading: false,
      renderKey: 0,
      items: [],
      poznamka: '',
      menu: [
      //{ nazov: 'Upraviť', icon: 'mdi-pencil-outline' },
          {
              nazov: 'Zobraziť dokument',
              icon: 'mdi-file-download-outline',
          },
          {
              nazov: 'Zmazať',
              icon: 'mdi-trash-can-outline',
              color: 'negative-500',
          },
      ],
      headers: [
          { text: 'Názov typu dokumentu', value: 'nazov_typ_dokumentu' },
          //  { text: 'Názov súboru', value: 'povodny_nazov' }, dat na hover nech ho zobrazi aj s poznamkou
          { text: 'Modifikované', value: 'datum_aktualizacie' },
          { text: 'Poznámka', value: 'poznamka' },
          { text: 'Akcie', value: 'akcie', sortable: false },
      ],
      newId: null,
      cisloPredmetu: '0',
      cisloLz: '',
      cisloPlz: '',
      cisloDokladu: '',
    };
  },
};
</script>
